import { render, staticRenderFns } from "./HierarchicalAllocation.vue?vue&type=template&id=62254d14&scoped=true"
import script from "./HierarchicalAllocation.vue?vue&type=script&lang=js"
export * from "./HierarchicalAllocation.vue?vue&type=script&lang=js"
import style0 from "./HierarchicalAllocation.vue?vue&type=style&index=0&id=62254d14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62254d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62254d14')) {
      api.createRecord('62254d14', component.options)
    } else {
      api.reload('62254d14', component.options)
    }
    module.hot.accept("./HierarchicalAllocation.vue?vue&type=template&id=62254d14&scoped=true", function () {
      api.rerender('62254d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/components/HierarchicalAllocation.vue"
export default component.exports